import { useState } from "react";
import { trpc } from "@/lib/trpc";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { toUserFriendlyError } from "@/lib/error-messages";

export function NewPipelineSheet({
  open,
  onOpenChange,
  onCreated,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  onCreated?: (id: number) => void;
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const utils = trpc.useUtils();
  const create = trpc.crm.pipelines.create.useMutation({
    onSuccess: (p: any) => {
      toast.success("Funil criado");
      utils.crm.pipelines.list.invalidate();
      onOpenChange(false);
      setName("");
      setDescription("");
      setIsDefault(false);
      if (p?.id) onCreated?.(p.id);
    },
    onError: (e) => toast.error(toUserFriendlyError(e, "Erro ao criar funil")),
  });
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="sm:max-w-[420px] p-0 flex flex-col">
        <SheetHeader className="px-6 pt-6 pb-4 border-b">
          <SheetTitle>Novo funil</SheetTitle>
          <SheetDescription>
            Crie um funil para segmentar suas oportunidades (ex.: Vendas B2G, Renovação).
          </SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-4">
          <div>
            <Label className="text-xs">Nome</Label>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Vendas B2G"
              className="mt-1"
              autoFocus
            />
          </div>
          <div>
            <Label className="text-xs">Descrição (opcional)</Label>
            <Input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Licitações e prospecção ativa em órgãos públicos"
              className="mt-1"
            />
          </div>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={isDefault}
              onChange={(e) => setIsDefault(e.target.checked)}
              className="h-4 w-4"
            />
            <span className="text-sm">Definir como padrão</span>
          </label>
        </div>
        <SheetFooter className="border-t px-6 py-4 bg-muted/30">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button
            onClick={() => {
              if (!name.trim()) return toast.error("Nome obrigatório");
              create.mutate({
                name: name.trim(),
                description: description || null,
                isDefault,
              });
            }}
            disabled={create.isPending}
          >
            {create.isPending && <Loader2 className="h-4 w-4 mr-1.5 animate-spin" />}
            Criar funil
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
